import { render, staticRenderFns } from "./association_detail_info.vue?vue&type=template&id=3f295f80&scoped=true&"
import script from "./association_detail_info.vue?vue&type=script&lang=js&"
export * from "./association_detail_info.vue?vue&type=script&lang=js&"
import style0 from "./association_detail_info.vue?vue&type=style&index=0&id=3f295f80&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f295f80",
  null
  
)

export default component.exports